export function setPersonDoc( doc ){
    return {
        type: "SET_PERSON_DOC",
        payload: doc
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/document-component/actions.js